import React, {Component, Suspense, lazy} from "react";
import { withStyles } from '@mui/styles';
import {
  List, 
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Collapse,
  createChainedFunction
} from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import Button from '@mui/material/Button';
import Iframe from 'react-iframe'

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { APIGetpdf } from './Api'
import apiConfig from './config/api'
import {Document, Page } from 'react-pdf';
import FileViewer from 'react-file-viewer';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import pdf_config from './configs/pdf_configs'
import {Alerts4} from './Alerts'

// The following lines live together to get Access to the PDFPages class
import {CopyToClipboard} from 'react-copy-to-clipboard';

var  json 
var pdf_pages 

const MyIframe = lazy(() => import("./MyIframe"));


const console_log = (text) => { 
  return  // Comment out if yoy want logging
  console_log(text)
}
const ColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', // theme.palette.getContrastText(lightGreen[50]),
    backgroundColor: '#ff3099',
    '&:hover': {
      backgroundColor: '#ff3099',
    },
  },
}))(Button);

const SmallColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', 
    backgroundColor: '#04c659',
    '&:hover': {
      backgroundColor: '#04a659',
    },
    fontSize: '10px',
    paddingTop: '2px',
    paddingBottom: '2px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginLeft: '5px',
    marginRight: '5px'
  },
}))(Button);


const checkProps =(prop) => {
  return typeof prop !== "undefined" && prop ? true : false
}
class OrderAgreement extends Component {
  constructor(props) {
    super(props);
    this.state = {
        origprops: props,
        saletype: props.saletype,
        items: props.slides,
        pdfpreview: '/live/templates/pdf/',
        pdfpage: 'page1.pdf',
        pageNumber: 1,
        numPages: 1,
        pdffile: '',
        slide_no: '',
        slide_id: '',
        pdf_file_path: '',
        is_loading: false,
        preview_file: '',
        show_preview: false,
        preview_page: 1,
        confirmPreview: false,
        show_alert: false,
        alert_severity: 'info',
        alert_text: '',
        ismounted: false,
        presentation_versions: props.presentation_versions ? props.presentation_versions : [{id: `${props.flg_id}.pdf`, description: 'Default System Proposal'}],
        selected_presentation: checkProps(props.selected_presentation) ? props.selected_presentation : `${props.flg_id}.pdf`,
        copied: [],
        force_reload: Date.now()
    };
  }

  componentDidMount = async () => {
    this.doMountandUpdate('Exceiption caught in componentDidMount OrderAgreement')

  }

  componentDidUpdate = async (prevProps, prevState) => {
    try{
    if(prevProps.force_reload != this.props.force_reload)
      this.doMountandUpdate('Exceiption caught in componentDidUpdate OrderAgreement')
    }catch(exception) {
      console.log(`componentDidUpdate Exception caught ${exception}`)
    }
  }
  static getDerivedStateFromProps(props, state) {
    if(props.force_reload != state.force_reload) 
      return({force_reload: props.force_reload})
    else  
      return null
  }


  doMountandUpdate(msg){
    try {
      //console.clear()

      const dt = new Date()
      const create_dt = `${dt.getDate()}/${dt.getMonth()+1}/${dt.getFullYear()} at ${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()}`
      this.DoOpenPres()
      //console.log("#### OrderAgreement Component Did Mount ####")
      }catch(err) {
        console.log(msg)
        console.log(err)
      }

  }
  onDocumentLoadSuccessPages = ({numPages}) => {
    //console.log("onDocumentLoadSuccessPages")
    //console.log(numPages)

    if(typeof numPages !== "undefined" )
      this.setState({is_loading: false,num_pages: numPages, numPages})
    else  
      this.setState({is_loading: false})
    //this.setState({numPages: event.target.value})
  }
  onDocumentLoadSuccess = (event) => {

    if(typeof event !== "undefined" && typeof event.target !== "undefined")
      this.setState({is_loading: false,num_pages: event, numPages: event})
    else  
      this.setState({is_loading: false})
    //this.setState({numPages: event.target.value})
  }

  // Filter to see if this slide should show up in the deck or not
  

  DoOpenPres = async () => {
    const flg_id = this.props.flg_id
    var pdffile =  `${pdf_config.dir_path}/${flg_id}/pdf/order_${flg_id}.pdf'`
    var output =  `order_${flg_id}.pdf`
    //var output =  '/presenter/documents/customers/' + flg_id + '/pdf/' + flg_id + '.pdf'
    //var preview = await APIGetpdf(output)
    let preview = `${apiConfig.baseUrl}/api/pdf/quote/${flg_id}`

    this.setState({pdffile: preview, preview_file: preview, show_preview: true,confirmPreview: this.state.preview_page > 1 ? true: false,})
  } 

  handlePreview = (events ) => {
    if(events)
      this.setState({confirmPreview: false})
    else
      this.setState({confirmPreview: false, preview_page: 1})
  }  

  ClosePreview = () => { 
    this.setState({show_preview: false})
  }
  updatePage = (page) => {
    this.setState({preview_page: page})
  }

  changePage = (offset) => {
    this.setState({pageNumber: this.state.pageNumber + offset})
  }
  selectPage = (event) => {
    this.setState({pageNumber: event.target.value})    
  }

 previousPage = () => {
    this.changePage(-1);
  }

  nextPage = () => {
    this.changePage(1);
  }


copyURL = (index) =>{
  let copied = this.state.copied;
  copied[index] = true;
  this.setState({copied})
}
onError= (msg) => {
  console.log(msg);
}

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
    render() {
        const { classes } = this.props;
        const ismounted = this.state.ismounted
        const { pdffile, slide_no, pageNumber, numPages } = this.state
        const pv = this.state.presentation_versions
        let pages = []
        for(let i=1; i<=numPages; i++) pages.push({text: `Page ${i}`, pageNumber: i})
        //console.log(`pdffile = ${pdffile}`)
        return(
            <div className={classes.mainDiv} style={{display: 'inline-block', textAlign: 'start'}} >
                <Collapse in={this.state.show_alert}> 
                    <Alert
                        variant='outlined'
                        style={{width: '800px', alignItems: 'center', textAlign: 'top', marginTop: '10px'}} 
                        severity={this.state.alert_severity}          
                        action={
                            <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                this.setState({show_alert: false})
                            }}
                            >
                            <CloseIcon fontSize="inherit" />
                            </IconButton > 
                        } >
                        {this.state.alert_text}
                    </Alert>
                </Collapse> 
                        
                <div key={`div_${this.props.force_reload??Date.now()}`} style={{top: 0, left: 5, height: '800px', position: "absolute", overflowY: 'scroll'}} >
                    <Backdrop className={classes.backdrop} open={this.state.is_loading} >
                        <CircularProgress color="secondary" size={150}/>
                    </Backdrop>
                    {1==2 && pdffile > ""  &&       
                        <Suspense fallback={<div>Loading...</div>}>
                            <MyIframe key={this.props.force_reload??Date.now()} src={pdffile} width="1024px" height="768px" />
                        </Suspense> 
                    }
                    <Iframe key={this.props.force_reload??Date.now()} src={pdffile} width="1024px" height="768px" />
                </div>
            </div>
        )
    }
}

const styles = theme => ({
  document: {
    position: 'absolute',
    border: '1px solid black',
  },
  backdrop: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1000,
      width: '100%',
      height: '100%'
  },
  buttonspace: {
    marginRight: '10px'
  },
  fullscreen: {
    backgroundColor: "#fff",
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  version_descriptions: {
    fontSize: '12px',
    width: '50%',
    maxWidth: '450px',
  },
  version_input: {
    fontSize: '12px',
    width: '250px',
    maxWidth: '250px',
  },
  versionBox: {
    width: '80%', 
    maxWidth: '800px',
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginTop: '5px',
    display: "flex",
    alignItems: "center"
  },
  mainDiv: {
    position: 'relative', 
    height: '600px', 
    width: '1280px ',
  },
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  }
});

export default withStyles(styles)(OrderAgreement)
